import $ from "jquery";
import "what-input";

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
//require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import "./lib/foundation-explicit-pieces";
import "slick-carousel/slick/slick";
import "hc-sticky/dist/hc-sticky";
import LocomotiveScroll from "locomotive-scroll";
import "lazysizes";
// import gsap from "gsap";
// import ScrollTrigger from "gsap/ScrollTrigger";
import AOS from "aos";
import slidebars from "exports-loader?slidebars!Slidebars/dist/slidebars.js";
import "simplelightbox/dist/simple-lightbox.jquery";

$(document).foundation();

$(document).ready(function () {
  // const myScroll = new LocomotiveScroll();

  var direction =
    $("html").css("direction").toLowerCase() === "rtl" ? "right" : "left";
  var direction_boolean = $("html").css("direction").toLowerCase() === "rtl";

  // start navpanel
  // Initialize Slidebars
  var controller = new slidebars();
  controller.init();

  $(document).on("click", ".toggle-nav-panel", function (event) {
    // Stop default action and bubbling
    event.stopPropagation();
    event.preventDefault();

    // $('.toggle-nav-panel').find('i').toggleClass('icon-menu icon-close');
    $(".toggle-nav-panel").toggleClass("is-active");
    //console.log("panel");
    // Toggle the Slidebar with id 'id-4'
    controller.toggle("nav-panel");
  });

  // Add close class to canvas container when Slidebar is opening
  $(controller.events).on("opening", function (event) {
    $('[canvas="container"]').addClass("sb-opening");
  });

  // Add close class to canvas container when Slidebar is opening
  $(controller.events).on("opened", function (event) {
    $('[canvas="container"]').addClass("sb-opened");
  });

  // Remove close class from canvas container when Slidebar is closing
  $(controller.events).on("closing", function (event) {
    $('[canvas="container"]').removeClass("sb-opening");
  });

  // Remove close class from canvas container when Slidebar is closing
  $(controller.events).on("closed", function (event) {
    $('[canvas="container"]').removeClass("sb-opened");
  });

  // Close any
  $(document).on("click", "#sb-blocker, .close-panel span", function (event) {
    //.sb-opening
    if (controller.getActiveSlidebar()) {
      event.preventDefault();
      event.stopPropagation();
      controller.close();
    }
    $(".toggle-nav-panel").removeClass("is-active");
    // $('.toggle-nav-panel').find('i').removeClass('icon-close');
    // $('.toggle-nav-panel').find('i').addClass('icon-menu');
  });

  // end navpanel

  // slick presentation

  if ($(".slick-presentation").length) {
    var slickPresentation = $(".slick-presentation").slick({
      lazyload: "progressive",
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      rtl: direction_boolean,
    });

    slickPresentation.on("init", function (event, slick) {
     // scroller.update();
    });

    $(".slick-presentation a").simpleLightbox({
      rtl: direction_boolean,
    });
  }

  // var $expertiseSlider = $('#expertise-slider');
  // $expertiseSlider.slick({
  //     lazyLoad: 'progressive',
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     arrows: true,
  //     fade: true,
  //     dots: false,
  //     rtl: direction_boolean,
  //     appendArrows: $('.c-arrows'),
  //     adaptiveHeight: true
  // });

  // $expertiseSlider.on('init', function(event, slick){
  //  //   scroller.update()
  // });

  const scroller = new LocomotiveScroll({
    el: document.querySelector("[data-scroll-container]"),
    smooth: true,
    // getSpeed: true,
    // getDirection: true,
    // inertia: 0.75,
    // useKeyboard: true,
    mobile: {
      smooth: true,
    },
    tablet: {
      smooth: true,
      breakpoint: 0,
    },
  });

  document.addEventListener("lazyloaded", function () {
    scroller.update();
  });

  if ($("body").hasClass("user-logged-in")) {
    scroller.update();
  }

  AOS.init({
    once: true,
    duration: 1200,
  });

  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("aos-animate");
      } else {
        entry.target.classList.remove("aos-animate");
      }
    });
  });
  document.querySelectorAll("[data-aos]").forEach((aosElem) => {
    observer.observe(aosElem);
  });

  // from override gn js

  var supportOffset = window.pageYOffset !== undefined,
    lastKnownPos = 0,
    ticking = false,
    scrollDir,
    currYPos;

  function doSomething(scrollPos, scrollDir) {
    // Your code goes here...
    //console.log('scroll pos: ' + scrollPos + ' | scroll dir: ' + scrollDir);
    if (scrollPos >= 200 && scrollDir == "down") {
      // $('.main-header-inner').css({ "background-color": "#0B2538" });
      $(".menu").removeClass("nav-top");
      $(".big-logo").css({ display: "none" });
      $(".small-logo").css({ display: "block" });
      // $('#sticky-header').addClass('small-header');
      $("#sticky-header").addClass("sticky-active");
    }

    if (!$(".inner-page").length) {
      if (scrollPos <= 200 && scrollDir == "up") {
        // $('#sticky-header').removeClass('small-header');
        $("#sticky-header").removeClass("sticky-active");
        // $('.main-header-inner').css({ "background-color": "unset" });
        $(".menu").addClass("nav-top");
        $(".small-logo").css({ display: "none" });
        $(".big-logo").css({ display: "block" });
      }
    }
  }

  var lastScrollTop = 0;

  scroller.on("scroll", (position) => {
    var st = position.scroll.y;
    scrollDir = st > position.scroll.y ? "up" : "down";

    if (!ticking) {
      window.requestAnimationFrame(function () {
        doSomething(lastKnownPos, scrollDir);
        ticking = false;
      });
    }
    ticking = true;

    lastScrollTop = st;
  });

  scroller.on("scroll", (position) => {
    currYPos = supportOffset ? position.scroll.y : document.body.scrollTop;
    scrollDir = lastKnownPos > currYPos ? "up" : "down";
    lastKnownPos = currYPos;

    if (!ticking) {
      window.requestAnimationFrame(function () {
        doSomething(lastKnownPos, scrollDir);
        ticking = false;
      });
    }
    ticking = true;
  });
});

import "../js/override.gn";
